class OHeader {
	/** @param {HTMLElement} element */
	constructor(element) {
		this.element = element;
		const backdropElement = element.querySelector('.o-header__backdrop');
		/** mobile navigation popovers (search, main nav) */
		const popoverElements = element.querySelectorAll('[popover]');

		popoverElements.forEach((popoverElement) => {
			popoverElement.addEventListener('toggle', (/** @type {ToggleEvent} */ event) => {
				if (event.newState === 'closed') {
					this.hideAllPopovers();
				}
			});
		});

		backdropElement.addEventListener('click', () => {
			this.hideAllPopovers();
		});
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				this.hideAllPopovers();
			}
		});

		window.addEventListener('load', () => {
			this.setMainnavOffset();
		});
		window.addEventListener('resize', () => {
			this.setMainnavOffset();
		});

		// Init
		this.setMainnavOffset();
	}

	hideAllPopovers() {
		const { element } = this;
		element.querySelectorAll('[data-popover-id][data-stack="1"]')
			.forEach((_) => _.toggleAttribute('hidden', true));
	}

	setMainnavOffset() {
		const {
			offsetLeft,
		} = this.element.querySelector('.o-header__mainnav');
		this.element.style.setProperty('--mainnav-offset-inline-start', `${offsetLeft}px`);
	}
}

document.querySelectorAll('.o-header').forEach((_) => new OHeader(_));
